import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquized: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="squized,centered,aligned"><path d="M12 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5 9L8 12L5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19 9L16 12L19 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.5 12H1.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M22.25 12H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquized;
